export const HOME_ROUTE = '/';

// export const CASH_SALES_REPORT = '/cash-sales-report';
// export const INVOICE_REPORT = '/invoice-report';
export const CASH_SALES_FOR_APPROVAL = '/cash-sales-for-approval';
export const INVOICE_FOR_APPROVAL = '/invoice-for-approval';
export const CASH_SALES_UPLOAD = '/cash-sales-upload';
export const INVOICE_UPLOAD = '/invoice-upload';
export const BACK_TO_PMS = 'https://pms.mytownph.com/';
